// Api proxy definitions

export const ApiMap = {
  BLOGS: {
    getUrl: () => `blog-settings/v1/blogs`,
    regex: new RegExp('^blog-settings/v1/blogs$'),
    methods: ['GET']
  },
  CTAS: {
    getUrl: guid => `ctas/v3/placements/${guid}`,
    regex: new RegExp('^ctas/v3/placements/[a-zA-Z0-9-_]+$'),
    methods: ['GET']
  },
  FILE_RESOLVE: {
    getUrl: () => 'filemanager/api/v2/files/resolve',
    regex: new RegExp('^filemanager/api/v2/files/resolve$'),
    methods: ['GET']
  },
  FILE_UPLOAD_URL: {
    getUrl: () => `filemanager/api/v3/files/synchronous-download-from-url`,
    regex: new RegExp('^filemanager/api/v3/files/synchronous-download-from-url$'),
    methods: ['POST']
  },
  FORMS: {
    getUrl: guid => `forms/v2/forms/${guid}`,
    regex: new RegExp('^forms/v2/forms/[a-zA-Z0-9-_]+$'),
    methods: ['GET']
  },
  FORMS_LIST: {
    getUrl: () => `forms/v2/forms`,
    regex: new RegExp('^forms/v2/forms$'),
    methods: ['GET']
  },
  MEETINGS: {
    getUrl: () => `meetings/v2/link/portal`,
    regex: new RegExp('^meetings/v2/link/portal$'),
    methods: ['GET']
  },
  MEETINGS_SEARCH: {
    getUrl: slug => `meetings/v1/link/slug/${slug}`,
    regex: new RegExp('^meetings/v1/link/slug/([a-zA-Z0-9-_]+((/|%2F)[a-zA-Z0-9-_]+)*)$'),
    methods: ['GET']
  },
  PAGES_CONTENT: {
    getUrl: () => `content/api/v4/contents`,
    regex: new RegExp('^content/api/v4/contents$'),
    methods: ['GET']
  },
  PAGES_SEARCH: {
    getUrl: () => `contentsearch/v2/search/internal`,
    regex: new RegExp('^contentsearch/v2/search/internal$'),
    methods: ['GET']
  },
  SNIPPETS: {
    getUrl: () => `salescontentsearch/v2/search`,
    regex: new RegExp('^salescontentsearch/v2/search$'),
    methods: ['POST']
  },
  USERS: {
    getUrl: () => `users/v2/app/hub-users`,
    regex: new RegExp('^users/v2/app/hub-users$'),
    methods: ['GET']
  },
  PROPERTIES: {
    getUrl: category => `properties/v4/${category}`,
    regex: new RegExp('^properties/v4/[a-zA-Z0-9-_.]+$'),
    methods: ['GET']
  },
  PATHS: {
    getUrl: () => `data-tokens/v1`,
    regex: new RegExp('^data-tokens/v1$'),
    methods: ['POST']
  },
  CUSTOM_OBJECT_META: {
    getUrl: () => 'crm-object-schemas/v3/schemas/',
    regex: new RegExp('^crm-object-schemas/v3/schemas/$'),
    methods: ['GET']
  },
  OEMBED_PROXY: {
    getUrl: () => `oembedproxy/v1/oembed`,
    regex: new RegExp('^oembedproxy/v1/oembed$'),
    methods: ['GET']
  },
  OWNERS: {
    getUrl: () => `owners/v2/owners`,
    regex: new RegExp('^owners/v2/owners$'),
    methods: ['GET']
  },
  SITE_SETTINGS: {
    getUrl: portalId => `content-settings/v1/site-settings/by-portal-id/${portalId}`,
    regex: new RegExp('^content-settings/v1/site-settings/by-portal-id/[0-9]+$'),
    methods: ['GET']
  },
  PORTAL_CURRENCY: {
    getUrl: () => `multi-currency/v1/currencies/information`,
    regex: new RegExp('^multi-currency/v1/currencies/information$'),
    methods: ['GET']
  },
  BRAND_COLORS: {
    getUrl: () => 'branding/v1/colors',
    regex: new RegExp('^branding/v1/colors$'),
    methods: ['GET']
  },
  BRAND_COLORS_BY_BU_ID: {
    getUrl: () => 'branding/v1/colors/brand-kit',
    regex: new RegExp('^branding/v1/colors/brand-kit$'),
    methods: ['GET']
  },
  CUSTOM_BRAND_FONTS: {
    getUrl: () => `branding/v1/fonts-with-variants`,
    regex: new RegExp('^branding/v1/fonts-with-variants$'),
    methods: ['GET']
  },
  BRAND_KIT_FONTS: {
    getUrl: () => `branding/v1/font-meta`,
    regex: new RegExp('^branding/v1/font-meta$'),
    methods: ['GET']
  },
  BRAND_KIT_BY_BU_ID: {
    getUrl: businessUnitId => `branding/v1/brand-kit/business-unit/${businessUnitId}`,
    regex: new RegExp('^branding/v1/brand-kit/business-unit/[0-9]+$'),
    methods: ['GET']
  },
  GOOGLE_FONTS: {
    getUrl: fontName => `google-fonts/v1/families/${encodeURIComponent(String(fontName))}`,
    regex: new RegExp('^google-fonts/v1/families/[a-zA-Z0-9-_.~%+]+$'),
    methods: ['GET']
  },
  ICON_SET: {
    getUrl: setName => `content-icons/v1/sets/${setName}`,
    regex: new RegExp(`^content-icons/v1/sets/[a-zA-Z0-9-._]+$`),
    methods: ['GET']
  },
  WEB_INTERACTIVES: {
    getUrl: () => `crm-search/search`,
    regex: new RegExp(`^crm-search/search$`),
    methods: ['POST']
  }
};